import React from "react";
import { useTranslation } from "react-i18next";
import { DrawerFooter } from "@/components/ui/drawer";
import { Button } from "@/components/ui/button";
import { ADD_CUSTOM_FIELD_TRANSLATION_KEY } from "../const";

interface FieldFormFooterProps {
  isFormValid: boolean;
  isSubmitting: boolean;
  onSubmit: () => void;
  onCancel: () => void;
  onDelete?: () => void;
  isEditMode?: boolean;
}

export const FieldFormFooter: React.FC<FieldFormFooterProps> = ({
  isFormValid,
  isSubmitting,
  onSubmit,
  onCancel,
  onDelete,
  isEditMode = false
}) => {
  const { t } = useTranslation();

  return (
    <DrawerFooter>
      <div className="flex justify-between gap-2 w-full p-4 border-t-[0.5px] border-border-border1">
        {isEditMode && onDelete ? (
          <Button
            destructive
            variant="tertiary"
            onClick={onDelete}
            className="h-9"
          >
            {t(`${ADD_CUSTOM_FIELD_TRANSLATION_KEY}.delete`)}
          </Button>
        ) : (
          <div />
        )}

        <div className="flex gap-2 ml-auto">
          <Button variant="secondaryNoBg" onClick={onCancel} className="h-9">
            {t("cancel")}
          </Button>
          <Button
            onClick={onSubmit}
            disabled={!isFormValid || isSubmitting}
            className="h-9"
          >
            {isEditMode
              ? t(`${ADD_CUSTOM_FIELD_TRANSLATION_KEY}.save`)
              : t(`${ADD_CUSTOM_FIELD_TRANSLATION_KEY}.addField`)}
          </Button>
        </div>
      </div>
    </DrawerFooter>
  );
};
